import React, { useEffect } from "react";
import { useUiValue } from "stores/uiContext";
import styled, { keyframes } from "styled-components";
import { useState } from "react";
import breakpoints from "utils/breakpoints";
import useBreakpoint from "utils/hooks/useBreakpoint";

import loadable from "@loadable/component";
const FormsModal = loadable(() =>
  import("components/components/organisms/FormsModal")
);

const fadeDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const FlayoutContainer = styled.div`
  z-index: ${({ showGalleryModal, showSuccessModal }) =>
    showGalleryModal && !showSuccessModal ? `94` : `92`};
  animation: ${fadeDown} 0.5s ease-out;

  @media ${breakpoints.lg} {
    top: ${({ top }) => top}px;
    height: calc(100vh - ${({ top }) => top}px);
  }
`;

const RegistrationModal = ({ fields, rendering: { placeholders } }) => {
  const breakpoint = useBreakpoint(
    typeof window !== "undefined" && window.innerWidth
  );
  const isMobile = ["sm", "xs", "md"].includes(breakpoint);

  const [
    { showRegistrationModal, showGalleryModal, showSuccessModal },
  ] = useUiValue();
  const [top, setTop] = useState(0);

  useEffect(() => {
    const body = document.getElementsByTagName("body")[0];

    if (showRegistrationModal) {
      body.style.overflowY = "hidden";
      const breadcrumb = document.getElementById("breadcrumb") || {};
      const notificationBanner = document.getElementById("notification-banner");

      const scrollTop = window.pageYOffset;
      const breadcrumbOffset = breadcrumb.offsetTop || 0;
      const notificationBannerOffset = notificationBanner.offsetTop;
      const distance = breadcrumbOffset + notificationBannerOffset - scrollTop;

      const offset =
        distance +
        (breadcrumb.offsetHeight || 0) +
        notificationBanner.offsetHeight;

      if (offset > 0 && scrollTop <= 300) {
        setTop(offset);
      } else {
        const detailsBlockBar = document.getElementById("detailsBlockBar");
        const detailsOffset = detailsBlockBar.offsetTop;
        const detailsHeight = detailsBlockBar.offsetHeight;

        const distanceDetails = detailsOffset + detailsHeight;
        setTop(distanceDetails);
      }
    } else {
      body.style.overflowY = "auto";
    }
  }, [showRegistrationModal]);

  if (!showRegistrationModal || (!top && !isMobile && !showGalleryModal)) {
    return null;
  }

  return (
    <FlayoutContainer
      className="fixed h-screen top-0 overflow-y-auto bg-dark-gray-bg"
      top={!showGalleryModal ? top : 0}
      showGalleryModal={showGalleryModal}
      showSuccessModal={showSuccessModal}
    >
      <FormsModal fields={fields} placeholders={placeholders} />
    </FlayoutContainer>
  );
};

export default RegistrationModal;
